/* Resin Floor Supplies — header menu/drawer, basket count, tabs, category groups, form checks, floor coating calculator (30-9-2026, v2). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- desktop dropdowns ---------- */
  var subs = $$('[data-rfh-sub]');
  function closeSubs(except) {
    subs.forEach(function (b) { if (b === except) return; b.setAttribute('aria-expanded', 'false'); b.parentNode.classList.remove('is-open'); });
  }
  subs.forEach(function (b) {
    b.addEventListener('click', function () {
      var open = b.getAttribute('aria-expanded') !== 'true';
      closeSubs(b);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.parentNode.classList.toggle('is-open', open);
    });
    b.parentNode.addEventListener('keydown', function (e) { if (e.key === 'Escape' && b.getAttribute('aria-expanded') === 'true') { closeSubs(); b.focus(); } });
    b.parentNode.addEventListener('focusout', function (e) { if (!b.parentNode.contains(e.relatedTarget)) { b.setAttribute('aria-expanded', 'false'); b.parentNode.classList.remove('is-open'); } });
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('.rfh-nav__item')) closeSubs(); });

  /* ---------- mobile drawer ---------- */
  var drawer = $('[data-rfh-drawer]');
  var opener = $('[data-rfh-open]');
  function openDrawer() {
    drawer.hidden = false;
    document.documentElement.classList.add('rfh-lock');
    opener.setAttribute('aria-expanded', 'true');
    var first = $('.rfh-drawer__panel button, .rfh-drawer__panel a', drawer);
    if (first) first.focus();
  }
  function closeDrawer(noFocus) {
    if (drawer.hidden) return;
    drawer.hidden = true;
    document.documentElement.classList.remove('rfh-lock');
    opener.setAttribute('aria-expanded', 'false');
    if (!noFocus) opener.focus();
  }
  if (drawer && opener) {
    opener.addEventListener('click', openDrawer);
    drawer.addEventListener('click', function (e) {
      var t = e.target.closest('[data-rfh-dsub]');
      if (t) {
        var list = document.getElementById(t.getAttribute('aria-controls'));
        var open = t.getAttribute('aria-expanded') !== 'true';
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (list) list.hidden = !open;
        return;
      }
      var c = e.target.closest('[data-rfh-close]');
      if (c) closeDrawer(c.tagName === 'A');
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var f = $$('.rfh-drawer__panel a, .rfh-drawer__panel button', drawer).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    });
    window.matchMedia('(min-width: 1100px)').addEventListener('change', function (m) { if (m.matches) closeDrawer(true); });
  }

  /* ---------- basket: live count + open the theme's cart drawer when it exists ---------- */
  function refreshCount() {
    var n = $('[data-rfh-cart-count]'), a = $('[data-rfh-cart]');
    if (!n) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      n.textContent = c.item_count; n.hidden = c.item_count === 0;
      if (a) a.setAttribute('aria-label', 'Basket, ' + c.item_count + ' items');
    }).catch(function () {});
  }
  document.addEventListener('cart:update', refreshCount);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });
  var cartLink = $('[data-rfh-cart]');
  if (cartLink) cartLink.addEventListener('click', function (e) {
    var d = document.querySelector('cart-drawer-component');
    if (d && typeof d.open === 'function' && !e.metaKey && !e.ctrlKey) {
      try { e.preventDefault(); d.open(); } catch (err) { window.location.href = cartLink.href; }
    }
  });

  /* ---------- tabs (projects, which coating) ---------- */
  $$('[data-rfh-tabs]').forEach(function (list) {
    var tabs = $$('[role="tab"]', list);
    function select(t, focus) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) t.focus();
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel && list.hasAttribute('data-rfh-tabs-scroll') && window.matchMedia('(max-width: 749px)').matches) {
        var r = panel.getBoundingClientRect();
        if (r.top > window.innerHeight * 0.75 || r.top < 0) panel.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }
    }
    list.addEventListener('click', function (e) { var t = e.target.closest('[role="tab"]'); if (t) select(t); });
    list.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      var k = e.key, n = -1;
      if (k === 'ArrowRight' || k === 'ArrowDown') n = (i + 1) % tabs.length;
      else if (k === 'ArrowLeft' || k === 'ArrowUp') n = (i - 1 + tabs.length) % tabs.length;
      else if (k === 'Home') n = 0;
      else if (k === 'End') n = tabs.length - 1;
      if (n > -1) { e.preventDefault(); select(tabs[n], true); }
    });
  });

  /* ---------- footer: mobile accordions + back to top ---------- */
  var ft = $('[data-rfh-ft]');
  if (ft) {
    ft.classList.add('rfh-ft--js');
    $$('[data-rfh-ftcol]', ft).forEach(function (col) {
      var t = $('.rfh-ft__tog', col);
      t.addEventListener('click', function () {
        var open = t.getAttribute('aria-expanded') !== 'true';
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        col.classList.toggle('is-open', open);
      });
    });
    var top = $('[data-rfh-top]', ft);
    if (top) top.addEventListener('click', function (e) {
      e.preventDefault();
      var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var first = document.body.firstElementChild;
      window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
      var pw = document.querySelector('.page-wrapper');
      if (pw && pw.scrollTop > 0) pw.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
      var focusTo = $('.rfh-logo') || first;
      if (focusTo) focusTo.focus({ preventScroll: true });
    });
  }


  /* ---------- category directory: collapsible groups on phones, always open on larger screens ---------- */
  var groups = $$('[data-rfh-dgroup]');
  if (groups.length) {
    var mqd = window.matchMedia('(max-width: 599px)');
    var setGroups = function () { groups.forEach(function (g, k) { g.open = !mqd.matches || k === 0; }); };
    groups.forEach(function (g) {
      $('summary', g).addEventListener('click', function (e) { if (!mqd.matches) e.preventDefault(); });
    });
    setGroups();
    if (mqd.addEventListener) mqd.addEventListener('change', setGroups);
  }

  /* ---------- simple form checks with visible messages (no data leaves the page until the form is valid) ---------- */
  $$('form[data-rfh-validate], [data-rfh-validate] form').forEach(function (f) {
    f.setAttribute('novalidate', '');
    var msg = function (inp) {
      if (inp.validity.valueMissing) return 'Please fill in ' + (inp.getAttribute('data-rfh-name') || 'this field') + '.';
      if (inp.validity.typeMismatch) return 'Please enter a valid email address, e.g. name@example.co.uk.';
      return '';
    };
    var show = function (inp) {
      var id = inp.id + '-err', e = document.getElementById(id), m = msg(inp);
      if (!e) return !m;
      e.textContent = m; e.hidden = !m;
      if (m) inp.setAttribute('aria-invalid', 'true'); else inp.removeAttribute('aria-invalid');
      return !m;
    };
    f.addEventListener('submit', function (ev) {
      var first = null;
      $$('input[required], textarea[required]', f).forEach(function (inp) { if (!show(inp) && !first) first = inp; });
      if (first) { ev.preventDefault(); first.focus(); }
    });
    $$('input[required], textarea[required]', f).forEach(function (inp) {
      inp.addEventListener('blur', function () { if (inp.value !== '' || inp.hasAttribute('aria-invalid')) show(inp); });
      inp.addEventListener('input', function () { if (inp.hasAttribute('aria-invalid')) show(inp); });
    });
  });

  /* ---------- floor coating calculator ---------- */
  var calc = $('[data-rfh-calc]');
  if (!calc) return;
  var paints = [];
  try { paints = JSON.parse($('[data-rfh-paints]', calc).textContent); } catch (err) { paints = []; }
  if (!paints.length) return;
  var HEX = { 'light grey': '#B8BCBE', 'mid grey': '#8C9194', 'dark grey': '#4B5155', 'jet black': '#1C1D1F', 'black': '#1C1D1F', 'white': '#F2F2EE', 'light ivory': '#E8E0C6', 'cobalt blue': '#224C96', 'sky blue': '#6DA6D4', 'leaf green': '#3D7A3A', 'fern green': '#2E5E3E', 'golden yellow': '#E3A51B', 'vermillion': '#D5472C', 'tomato red': '#B7372A', 'traffic red': '#B32821', 'traffic yellow': '#F0B400' };
  function hexOf(name) { var k = String(name).toLowerCase().replace(/\s*\(.*\)\s*/, '').trim(); return HEX[k] || '#9A9EA3'; }
  function shortName(name) { return String(name).replace(/\s*\(.*\)\s*/, '').trim(); }
  function money(p) { return '£' + (p / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function kg(v) { var n = parseFloat(String(v).replace(',', '.')); return isNaN(n) ? 0 : n; }
  paints.forEach(function (p) {
    var names = (p.opts || []).map(function (o) { return String(o).toLowerCase(); });
    p.ci = names.indexOf('colour') > -1 ? names.indexOf('colour') : names.indexOf('color');
    p.si = names.indexOf('size');
    var rawCov = String(p.cov || '');
    p.cov = {};
    rawCov.split(',').forEach(function (pair) { var a = pair.split(':'); if (a.length === 2) p.cov[kg(a[0])] = kg(a[1]); });
    p.colours = [];
    p.v.forEach(function (v) { var c = p.ci > -1 ? v[1 + p.ci] : ''; if (p.colours.indexOf(c) < 0) p.colours.push(c); });
  });
  var AREA_MIN = 1, AREA_MAX = 500;
  var st = { paint: 0, area: 18, coats: 2, colour: 'Mid Grey', valid: true };
  var el = {
    pills: $('[data-rfh-paint-pills]', calc), area: $('[data-rfh-area]', calc), range: $('[data-rfh-range]', calc),
    areaErr: $('[data-rfh-area-err]', calc),
    sw: $('[data-rfh-swatches]', calc), colname: $('[data-rfh-colname]', calc), plink: $('[data-rfh-plink]', calc),
    note: $('[data-rfh-note]', calc), total: $('[data-rfh-total]', calc), packs: $('[data-rfh-packs]', calc),
    cov: $('[data-rfh-cov]', calc), why: $('[data-rfh-why]', calc), add: $('[data-rfh-add]', calc), msg: $('[data-rfh-msg]', calc),
    tag: $('[data-rfh-tag]', calc), floor: $('[data-rfh-floor]', calc), sum: $('[data-rfh-summary]', calc),
    body: $('[data-rfh-calc-body]', calc), tog: $('[data-rfh-calc-tog]', calc), togT: $('[data-rfh-calc-tog-t]', calc)
  };
  el.pills.innerHTML = paints.map(function (p, i) {
    return '<label><input type="radio" name="rfh-paint" value="' + i + '"' + (i === 0 ? ' checked' : '') + '><span></span></label>';
  }).join('');
  $$('span', el.pills).forEach(function (s, i) { s.textContent = paints[i].label || paints[i].name; });

  function currentColour(p) {
    var match = p.colours.filter(function (c) { return shortName(c).toLowerCase() === shortName(st.colour).toLowerCase(); })[0];
    return match || p.colours[0];
  }
  function drawSwatches() {
    var p = paints[st.paint], cur = currentColour(p);
    el.sw.innerHTML = '';
    p.colours.forEach(function (c, i) {
      var lab = document.createElement('label');
      lab.className = 'rfh-sw__i';
      lab.title = shortName(c);
      var inp = document.createElement('input');
      inp.type = 'radio'; inp.name = 'rfh-colour'; inp.value = String(i);
      inp.setAttribute('aria-label', shortName(c));
      inp.checked = c === cur;
      inp.addEventListener('change', function () { if (inp.checked) { st.colour = c; update(); } });
      var chip = document.createElement('span');
      chip.style.background = hexOf(c);
      chip.setAttribute('aria-hidden', 'true');
      lab.appendChild(inp); lab.appendChild(chip);
      el.sw.appendChild(lab);
    });
  }
  function packsFor(p, colour) {
    var list = [];
    p.v.forEach(function (v) {
      var c = p.ci > -1 ? v[1 + p.ci] : '';
      if (c !== colour || !v[4]) return;
      var size = p.si > -1 ? kg(v[1 + p.si]) : 0;
      var cov = p.cov[size];
      if (!cov) return;
      list.push({ id: v[0], kg: size, cov: cov, price: v[3] });
    });
    return list.sort(function (a, b) { return a.kg - b.kg; });
  }
  function plan(need, packs) {
    if (!packs.length) return null;
    var big = packs[packs.length - 1], best = null;
    var lim = packs.map(function (pk, i) { return i === packs.length - 1 ? Math.ceil(need / big.cov) + 1 : 3; });
    var n = packs.map(function () { return 0; });
    (function walk(i) {
      if (i === packs.length) {
        var cov = 0, cost = 0;
        for (var j = 0; j < packs.length; j++) { cov += n[j] * packs[j].cov; cost += n[j] * packs[j].price; }
        if (cov >= need && (!best || cost < best.cost || (cost === best.cost && cov < best.cov))) best = { n: n.slice(), cov: cov, cost: cost };
        return;
      }
      for (var k = 0; k <= lim[i]; k++) { n[i] = k; walk(i + 1); }
      n[i] = 0;
    })(0);
    return best;
  }
  var last = null, lastCount = 0, busy = false;
  function setAddLabel() {
    if (busy) return;
    if (!st.valid || !last) { el.add.disabled = true; el.add.textContent = 'Add to basket'; return; }
    el.add.disabled = false;
    el.add.textContent = 'Add ' + lastCount + (lastCount === 1 ? ' tin' : ' tins') + ' to basket';
  }
  function update() {
    var p = paints[st.paint], colour = currentColour(p);
    var need = st.area * st.coats;
    var packs = packsFor(p, colour);
    var r = plan(need, packs);
    var cname = shortName(colour);
    el.colname.textContent = cname;
    el.tag.textContent = cname;
    el.floor.style.backgroundColor = hexOf(colour);
    el.plink.textContent = p.name + (colour ? ' — ' + cname : '');
    el.plink.setAttribute('href', p.url);
    el.note.textContent = p.note ? p.name + ': ' + p.note + '.' : '';
    el.msg.hidden = true;
    if (!r) {
      last = null; lastCount = 0;
      el.total.textContent = '—';
      el.packs.innerHTML = '';
      el.cov.textContent = 'This colour isn\'t available in the sizes we can calculate. Pick another colour or open the product page.';
      el.why.textContent = '';
      if (el.sum) el.sum.textContent = 'Estimate the tins you need';
      setAddLabel();
      $$('[data-rfh-mytotal]').forEach(function (x) { x.textContent = '—'; });
      return;
    }
    var items = [], count = 0;
    el.packs.innerHTML = '';
    for (var i = packs.length - 1; i >= 0; i--) if (r.n[i] > 0) {
      items.push({ id: packs[i].id, quantity: r.n[i] });
      count += r.n[i];
      var li = document.createElement('li');
      li.textContent = r.n[i] + ' × ' + packs[i].kg + ' kg';
      el.packs.appendChild(li);
    }
    last = items; lastCount = count;
    el.total.textContent = money(r.cost);
    el.cov.textContent = 'Covers at least ' + r.cov + ' m² · you need ' + need + ' m² (' + st.area + ' m² × ' + st.coats + (st.coats === 1 ? ' coat' : ' coats') + ')';
    var covTxt = packs.map(function (pk) { return pk.kg + ' kg = ' + pk.cov + ' m²'; }).join(', ');
    el.why.textContent = 'We multiply your floor area by the number of coats, then pick the lowest-cost mix of tins that covers it, using the low end of the maker\'s coverage per coat (' + covTxt + '). Available tins in this colour only.';
    if (el.sum) el.sum.textContent = st.area + ' m² · ' + st.coats + (st.coats === 1 ? ' coat' : ' coats') + ' · ' + cname + ' — ' + money(r.cost) + ' incl. VAT';
    setAddLabel();
    $$('[data-rfh-mytotal]').forEach(function (x) { x.textContent = money(r.cost); });
  }
  function areaError(t) {
    st.valid = !t;
    el.areaErr.textContent = t || '';
    el.areaErr.hidden = !t;
    if (t) el.area.setAttribute('aria-invalid', 'true'); else el.area.removeAttribute('aria-invalid');
    setAddLabel();
  }
  function readArea(raw) {
    var v = String(raw).trim();
    if (v === '') return { err: 'Enter a floor area from ' + AREA_MIN + ' to ' + AREA_MAX + ' m².' };
    var n = Number(v);
    if (isNaN(n)) return { err: 'Use numbers only, from ' + AREA_MIN + ' to ' + AREA_MAX + ' m².' };
    if (n < AREA_MIN || n > AREA_MAX) return { err: 'Enter a floor area from ' + AREA_MIN + ' to ' + AREA_MAX + ' m². For larger floors, ask for a trade quote below.', n: n };
    return { n: Math.max(AREA_MIN, Math.round(n)) };
  }
  function setArea(v) {
    var n = Math.min(AREA_MAX, Math.max(AREA_MIN, Math.round(Number(v)) || AREA_MIN));
    st.area = n;
    el.area.value = n;
    el.range.value = Math.min(n, Number(el.range.max));
    areaError('');
    update();
  }
  el.pills.addEventListener('change', function (e) { if (e.target.name === 'rfh-paint') { st.paint = Number(e.target.value); drawSwatches(); update(); } });
  calc.addEventListener('change', function (e) {
    if (e.target.name === 'rfh-coats') { st.coats = Number(e.target.value); update(); }
    if (e.target === el.area) {
      var a = readArea(el.area.value);
      if (a.err && a.n === undefined) { el.area.value = st.area; areaError(''); update(); }
      else setArea(a.n);
    }
  });
  el.area.addEventListener('input', function () {
    var a = readArea(el.area.value);
    if (a.err) { areaError(a.err); return; }
    st.area = a.n; el.range.value = Math.min(a.n, Number(el.range.max)); areaError(''); update();
  });
  el.range.addEventListener('input', function () { setArea(el.range.value); });
  calc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rfh-step]');
    if (b) setArea(st.area + Number(b.getAttribute('data-rfh-step')));
  });
  function say(t, err) {
    el.msg.classList.toggle('is-err', !!err);
    el.msg.textContent = t;
    el.msg.hidden = false;
  }
  el.add.addEventListener('click', function () {
    if (busy || !st.valid || !last || !last.length) return;
    busy = true;
    var n = lastCount;
    el.add.disabled = true;
    el.add.setAttribute('aria-busy', 'true');
    el.add.textContent = 'Adding ' + n + (n === 1 ? ' tin' : ' tins') + '…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: last }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        say('Added ' + n + (n === 1 ? ' tin' : ' tins') + ' to your basket. Opening your basket…');
        el.add.textContent = 'Added ✓';
        refreshCount();
        setTimeout(function () { window.location.href = '/cart'; }, 700);
      })
      .catch(function (err) {
        busy = false;
        el.add.removeAttribute('aria-busy');
        say((err && (err.description || err.message)) || 'Sorry, the tins couldn\'t be added. Please try again, or add them from the product page.', true);
        setAddLabel();
      });
  });

  /* phones: the calculator opens from a compact bar; entered values stay when it is closed */
  var mqc = window.matchMedia('(max-width: 749px)');
  var userOpened = false;
  function setOpen(open, focus) {
    el.body.hidden = !open;
    el.tog.setAttribute('aria-expanded', open ? 'true' : 'false');
    el.togT.textContent = open ? 'Hide calculator' : 'Open calculator';
    calc.classList.toggle('is-closed', !open);
    if (open && focus) { var f = $('input[name="rfh-paint"]:checked', calc); if (f) f.focus(); }
  }
  function applyMode() {
    el.tog.hidden = !mqc.matches;
    if (!mqc.matches) setOpen(true); else setOpen(userOpened);
  }
  el.tog.addEventListener('click', function () {
    var open = el.tog.getAttribute('aria-expanded') !== 'true';
    userOpened = open;
    setOpen(open, open);
  });
  if (mqc.addEventListener) mqc.addEventListener('change', applyMode);
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href$="#rfh-calc"]');
    if (a && mqc.matches) { userOpened = true; setOpen(true); }
  });
  if (location.hash === '#rfh-calc') userOpened = true;
  applyMode();

  drawSwatches();
  update();
})();
